import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
    PageAlwaysVisible,
    PageFull,
    PageTitle,
    Section_Title
} from "monica-alexandria";
import Timeline_ from "../../components/timeline/Timeline_";
import { read_activity_timeline_events, read_timeline_events } from "../../utils/timeline/timeline_normalization";
import { timelineSeed } from "./utils/timeline_seed";
import { legacyActivitySeed } from "./utils/legacy_activity_seed";

const TimeDummy = styled.div`
    display: grid;
    gap: 2rem;
    width: 100%;
    max-width: 96rem;
    margin: 0 auto;
    padding: var(--largePads) 0;
`;

const TimeDummyTimeline = styled.section`
    display: grid;
    gap: 1.6rem;
    min-width: 0;
`;

const timelineEvents = read_timeline_events(timelineSeed);

// Leaves the static timeline disconnected from pagination and retry actions.
const skip_timeline_action = () => {
    return undefined;
};

// Displays the production timeline against a complete deterministic Brand story.
export const TIME_DUMMY = () => {
    const { t } = useTranslation();
    const activityView = new URLSearchParams(window.location.search).get("view") === "activity";
    const events = activityView ? read_activity_timeline_events(legacyActivitySeed) : timelineEvents;

    return (
        <PageFull>
            <PageAlwaysVisible>
                <TimeDummy data-testid="time-dummy-page">
                    <PageTitle>
                        <h1>{t("Timeline dummy")}</h1>
                    </PageTitle>
                    <TimeDummyTimeline>
                        <Section_Title text={t("Timeline")} />
                        <Timeline_
                            events={events}
                            loading={false}
                            loadingMore={false}
                            hasMore={false}
                            error=""
                            publication={{ state: "synced" }}
                            onLoadMore={skip_timeline_action}
                            onRetry={skip_timeline_action}
                            t={t}
                        />
                    </TimeDummyTimeline>
                </TimeDummy>
            </PageAlwaysVisible>
        </PageFull>
    );
};
